module.exports = __webpack_public_path__ + "570bb8e916d7c02d38f348b125d2f83e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-36.svg
// module id = 574
// module chunks = 0